'use strict';

angular.module('rmRundown')
    .filter('rmRundownPresenters', require('./presenters'))
;